import { i18n } from 'src/i18n';
import formTemplateEnumerators from 'src/modules/formTemplate/formTemplateEnumerators';
import schemas from 'src/modules/shared/yup/yupImporterSchemas';

export default [
  {
    name: 'name',
    label: i18n('entities.formTemplate.fields.name'),
    schema: schemas.string(
      i18n('entities.formTemplate.fields.name'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'category',
    label: i18n('entities.formTemplate.fields.category'),
    schema: schemas.relationToOne(
      i18n('entities.formTemplate.fields.category'),
      {},
    ),
  },
  {
    name: 'description',
    label: i18n('entities.formTemplate.fields.description'),
    schema: schemas.string(
      i18n('entities.formTemplate.fields.description'),
      {},
    ),
  },
  {
    name: 'version',
    label: i18n('entities.formTemplate.fields.version'),
    schema: schemas.string(
      i18n('entities.formTemplate.fields.version'),
      {},
    ),
  },
  {
    name: 'previewImage',
    label: i18n(
      'entities.formTemplate.fields.previewImage',
    ),
    schema: schemas.images(
      i18n('entities.formTemplate.fields.previewImage'),
      {},
    ),
  },
  {
    name: 'validatorsRequired',
    label: i18n(
      'entities.formTemplate.fields.validatorsRequired',
    ),
    schema: schemas.boolean(
      i18n(
        'entities.formTemplate.fields.validatorsRequired',
      ),
      {},
    ),
  },
  {
    name: 'validators',
    label: i18n('entities.formTemplate.fields.validators'),
    schema: schemas.relationToMany(
      i18n('entities.formTemplate.fields.validators'),
      {},
    ),
  },
  {
    name: 'actionPlansRequired',
    label: i18n(
      'entities.formTemplate.fields.actionPlansRequired',
    ),
    schema: schemas.boolean(
      i18n(
        'entities.formTemplate.fields.actionPlansRequired',
      ),
      {},
    ),
  },
  {
    name: 'actionPlans',
    label: i18n('entities.formTemplate.fields.actionPlans'),
    schema: schemas.relationToMany(
      i18n('entities.formTemplate.fields.actionPlans'),
      {},
    ),
  },
  {
    name: 'adminsRequired',
    label: i18n(
      'entities.formTemplate.fields.adminsRequired',
    ),
    schema: schemas.boolean(
      i18n('entities.formTemplate.fields.adminsRequired'),
      {},
    ),
  },
  {
    name: 'administrators',
    label: i18n(
      'entities.formTemplate.fields.administrators',
    ),
    schema: schemas.relationToMany(
      i18n('entities.formTemplate.fields.administrators'),
      {},
    ),
  },
  {
    name: 'priority',
    label: i18n('entities.formTemplate.fields.priority'),
    schema: schemas.enumerator(
      i18n('entities.formTemplate.fields.priority'),
      {
        options: formTemplateEnumerators.priority,
      },
    ),
  },
];
